import { createRouter, createWebHistory } from 'vue-router';
import OverviewPage from '../pages/OverviewPage.vue';
import GoldPage from '../pages/GoldPage.vue';
import SilverPage from '../pages/SilverPage.vue';
import CopperPage from '../pages/CopperPage.vue';
import MarketChatPage from '../pages/MarketChatPage.vue';
import CalendarPage from '../pages/CalendarPage.vue';
import WeeklyReportPage from '../pages/WeeklyReportPage.vue';

const routes = [
  { path: '/', name: 'Overview', component: OverviewPage },
  { path: '/go', redirect: '/gold' },
  { path: '/gold', name: 'Gold', component: GoldPage },
  { path: '/sl', redirect: '/silver' },
  { path: '/silver', name: 'Silver', component: SilverPage },
  { path: '/cu', redirect: '/copper' },
  { path: '/copper', name: 'Copper', component: CopperPage },
  { path: '/market-chat', name: 'MarketChat', component: MarketChatPage },
  { path: '/chat', redirect: '/market-chat' },
  { path: '/calendar', name: 'Calendar', component: CalendarPage },
  { path: '/weekly-report', name: 'WeeklyReport', component: WeeklyReportPage },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
